module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-toast"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Toast")]), _vm._v(" "), _c('div', {
    staticClass: "page-toast-wrapper"
  }, [_c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openToast($event)
      }
    }
  }, [_vm._v("点击弹出 Toast")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openToastWithIcon($event)
      }
    }
  }, [_vm._v("点击弹出带有 icon 的 Toast")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openBottomToast($event)
      }
    }
  }, [_vm._v("自定义 Toast 位置")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1425d8bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/toast.vue
// module id = 269
// module chunks = 0